import Link from 'next/link';
import React from 'react';
import {
    StyledButtonsWrapper,
    StyledText,
    StyledWrapper,
} from 'src/features/white-labels/nftsuperlab/universe/components/discord/styles';
import { Button } from 'src/ui/common/atoms/button';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';

export const Discord = () => (
    <Spacing margin="80px 0 20px">
        <StyledWrapper>
            <Typography variant="title">
                For nærmere information, vejledning til køb og adgang til at få de nyeste oplysninger først:
            </Typography>
            <StyledButtonsWrapper>
                <Link href="https://discord.gg/wxMqPyAUvY">
                    <a target="_blank">
                        <Button variant="outline">Tilmeld dig Discord</Button>
                    </a>
                </Link>
            </StyledButtonsWrapper>
            <StyledText>
                Discord er en chat-server, hvor at du kan interagere med andre medlemmer samt få svar på dine spørgsmål
                vedr. projektet. Du tilgår serveren via linket ovenover og ved at oprette en bruger.
            </StyledText>
        </StyledWrapper>
    </Spacing>
);
